import { render, staticRenderFns } from "./RateRappelTable.vue?vue&type=template&id=2edbbf7e&scoped=true&lang=pug&"
import script from "./RateRappelTable.vue?vue&type=script&lang=js&"
export * from "./RateRappelTable.vue?vue&type=script&lang=js&"
import style0 from "./RateRappelTable.vue?vue&type=style&index=0&id=2edbbf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edbbf7e",
  null
  
)

export default component.exports